<lcs-advanced-multi-select
   [headerText]="labelSignal()"
   [triggerConfig]="triggerConfig()"
   [datasources]="[datasource()]"
   [hasRestoreDefaults]="false"
   (save)="onSave($event)"
   (selectedItemsChange)="onSelectedItemsChange($event)"
   (search)="onSearch($event)"
   (close)="onClose($event)"
   (openDialog)="onOpen($event)"
>
   <ng-template let-context advancedMultiSelectListItemDisplay>
      <lcs-advanced-multi-select-trigger [context]="context"> </lcs-advanced-multi-select-trigger>
   </ng-template>
</lcs-advanced-multi-select>
